// extracted by mini-css-extract-plugin
export default {"label":"OpenForBusiness_label__ltbDg","image":"OpenForBusiness_image__k-yZe","workflow":"OpenForBusiness_workflow__uztk6"};